module.exports = __webpack_public_path__ + "fonts/Raleway-SemiBoldItalic.2ed1e969.ttf";